<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div class="panel" v-loading="loading">
        <custom-table
            :page="page"
            :selPage="selPage"
            :tableHead="tableHead"
            :tbodyData="tbodyData"
            :noDataMessage="noDataMessage"
            @tableChange="pageHandle"
        >
            <div class="search-box" slot="search">
                <div class="select-type">
                    <span v-text="language.typeText"></span>
                    <el-select @change="selectHandle" v-model="type">
                        <el-option :key="k" :label="v" :value="k" v-for="(v,k) in language.operateTypeMapping"></el-option>
                    </el-select>
                </div>
                <div class="select-type">
                    <span v-text="language.operateDay"></span>
                    <el-date-picker
                        style="width:200px;"
                        type="date"
                        v-model="operateDay"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </div>
                <div class="select-type">
                    <el-button @click="filterHandle" type="primary" v-text="reuse.searchText"></el-button>
                </div>
                <div class="select-type">
                    <div @click="export2Excel" class="btn btn-default">
                    <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
                    {{reuse.downloadExcelForms}}
                    </div>
                </div>
            </div>
        </custom-table>
        <custom-table
        :tableHead="summaryHead"
        :pageEnable="false"
        :tbodyData="summaryData"
        :noDataMessage="noDataMessage"
        ></custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_MANAGER_OPERATE_LOG } from 'api/api'

const data = () => {
  return {
    tbodyData: [],
    summaryData: [],
    allData: [],
    tmpData: [],
    type: '-1',
    loading: false,
    operateDay: new Date(),
    noRecordReason: '',
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  }
}

const mixins = [
    require('common/mixin/base').base({ language: 'managerOperateRecord' }),
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
  tableHead() {
    const redColorColumns = ['old_profit','new_profit']
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.tableHead
  },
  summaryHead() {
    return this.language.summaryHead
  },
  noDataMessage() {
    return this.language.noData[this.noRecordReason]
  }
}

const created = function() {
    this.ajaxHandle();
}

const methods = {
    filterHandle() {
        this.page.active = 1
        this.ajaxHandle()
    },
    ajaxHandle() {
        this.loading = true;
        const operateDay = this.$moment(this.operateDay).format('YYYY-MM-DD')
        this.$http.get(URL_MANAGER_OPERATE_LOG, { params: { operateDay } }).then(res => {
            const [all, summary, noRecordReason] = res.data.data;
            this.allData = all || [];
            this.summaryData = summary || [];
            if(noRecordReason) this.noRecordReason = noRecordReason;
            else this.noRecordReason = ''
            this.allData.forEach(record =>  record.TYPE = this.language.operateTypeMapping[record.type] || '');
            this.selectHandle();
            this.loading = false;
        })
        .catch(e => {
            this.tbodyData = [];
            this.loading = false;
            alert(this.reuse.serverError);
        })
    },
    selectHandle() {
        this.page.active = 1
        this.tmpData = this.type > -1 ? this.allData.filter(v => v.type == this.type) : this.allData;
        this.pageHandle()
    },
    pageHandle() {
        const pageNum = this.page.active
        const pageSize = this.selPage.limit
        this.page.pageLeng = this.tmpData.length
        this.tbodyData = this.tmpData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
    },
    export2Excel() {
        require.ensure([], () => {
            const { export_json_to_multi_excel } = require('@/vendor/Export2Excel');
            const sheet1TitleObj = this.tableHead.reduce((p, c)=> {
                p[c.key] = c.value;
                return p;
            },{});
            const sheet2TitleObj = this.summaryHead.reduce((p, c)=> {
                p[c.key] = c.value;
                return p;
            },{});
            const sheet1Data = this.formatJson(Object.keys(sheet1TitleObj), this.allData);
            const sheet2Data = this.formatJson(Object.keys(sheet2TitleObj), this.summaryData);
            const excelName = `${this.language.downloadName}_${this.operateDay}`;
            export_json_to_multi_excel(
                [Object.values(sheet1TitleObj),Object.values(sheet2TitleObj)], 
                [sheet1Data, sheet2Data], 
                this.language.sheetNames, 
                excelName
            );
        })
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
    },
}

const components = {
  customTable
}

const watch = {
  language() {
    this.allData.forEach(v => (v.TYPE = this.language.operateTypeMapping[v.type] || ''));
  }
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
  watch,
}
</script>


// WEBPACK FOOTER //
// src/views/record/manager-operate-record.vue